// tslint:disable-next-line:interface-name
export interface ICryptoService {
  encrypt(message: string): Promise<string>;
}

class CryptoProvider {
  cryptoService: ICryptoService;
}

export default new CryptoProvider();
